<template>
  <div class="essay-body-box transition"  v-for="item in essayList" :key="item.id">
    <div class="essay-top-box transition">
      <h4>{{ item.title }}</h4>
      <div class="essay-top-information">
        <span class="essay-top-information-time">
          {{ item.create_time }}
        </span>

        <span class="essay-top-information-author"> 作者：{{ item.author }} </span>
      </div>
    </div>
    <div class="essay-content-box transition" v-html="item.content" ></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      id: "",
      content: "",
      title: "",
      author: "",
      date: "",
      essayList: [],
    };
  },
  mounted() {
    document.title = "杭开集团";

    this.id = this.$route.query.id;
    this.type = this.$route.query.type;
    this.Post();
    
    // this.content = this.$route.query.content;
    // this.title = this.$route.query.title;
    // this.author = this.$route.query.author;
    // this.date = this.$route.query.date;
    // console.log(this.$route.query.id, this.$route.query.type);
  },
  methods: {
    /*
      title:标题
      author:作者
      create_time:创建时间
      content:内容
    */
    Post() {
      var url =
        "http://demoapi.hkjt.cn/pages/essay.php?type=" +
        this.type +
        "&id=" +
        this.id;
      // console.log(url);
      this.axios
        .get(url)
        .then((res) => {
          res.data.forEach((item) => {
            this.essayList.push({
              title: item.title,
              author: item.author,
              create_time: item.create_time,
              content: item.content
            });
          });
          // console.log(this.essayList[0].content);
        })
        .catch((e) => {
          if (e.response) {
            //请求已发出，服务器返回状态码不是2xx。
            console.info(e.response.data);
            console.info(e.response.status);
            console.info(e.response.headers);
          } else if (e.request) {
            // 请求已发出，但没有收到响应
            // e.request 在浏览器里是一个XMLHttpRequest实例，
            // 在node中是一个http.ClientRequest实例
            console.info(e.request);
          } else {
            //发送请求时异常，捕捉到错误
            console.info("error", e.message);
          }
          console.info(e.config);
        });
    },
  },
};
</script>

<style>
.essay-top-information {
  color: #777777;
  margin-top: 0.7rem;
}

.essay-top-information-time {
  margin-right: 1rem;
}

.essay-top-box {
  text-align: center;
  margin-bottom: 1.5rem;
  width: 100vw;
}

.essay-body-box {
  margin-top: 2rem;
  width: 100vw;
  margin-top: 13rem;
}

.essay-content-box {
  width: 62.5rem;
  margin: 0 auto;
  padding-top: 2rem;
  border-top: 1px solid #777777;
  font-family: 微软雅黑;
  font-size: 1rem;
}

.essay-content-box > p > span > img {
  margin-top: 0.3rem;
}

@media screen and (max-width: 1045px) {
  .essay-top-box {
    width: 95%;
    margin: 0 auto 1.5rem auto;
  }

  .essay-content-box {
    width: 95%;
    margin: 0 auto;
  }
}

@media screen and (max-width: 991px) {
  .essay-body-box {
    margin-top: 8rem;
  }

  .essay-content-box {
    width: 80%;
    margin: 0 auto;
  }

  .essay-top-box {
    width: 80%;
    margin: 0 auto 1.5rem auto;
  }

  .essay-content-box > p > span > img,
  .essay-content-box > p > img {
    width: 100% !important;
    height: auto !important;
  }

  .essay-content-box > p {
    text-indent: 0 !important;
  }
}

@media screen and (max-width: 700px) {
  .essay-content-box {
    width: 95%;
  }

  .essay-content-box > p > *,
  .essay-content-box > p > span > * {
    width: 100% !important;
    height: auto !important;
  }
}

@media screen and (max-width: 540px) {
  .essay-top-box > h4 {
    font-size: 1.2rem;
  }

  /* .essay-content-box > p > span > img,
  .essay-content-box > p > img {
    width: 100% !important;
    height: auto !important;
  } */

  .essay-content-box > p {
    text-indent: 0 !important;
  }
}
</style>